import styled from "styled-components";
import TopBar from "../topBar/TopBar";
import DesktopNavbar from "./desktop/DesktopNavbar";
import MobileNavbar from "./mobile/MobileNavbar";

const Menubar = styled.div`
  margin: 0;
  z-index: 2 !important;
  color: white;
  height: 40px;
  width: 100%;
  position: sticky;
  align-items: center !important;
  top: 0;
  cursor: pointer;
  background-color: black;
`;
const Mobile = styled.div`
  @media (min-width: 1050px) {
    display: none;
  }
`;
const Desktop = styled.div`
  @media (max-width: 1050px) {
    display: none;
  }
`;

function Navbar() {
  return (
    <Menubar>
      <TopBar />
      <Mobile>
        <MobileNavbar />
      </Mobile>
      <Desktop>
        <DesktopNavbar />
      </Desktop>
    </Menubar>
  );
}

export default Navbar;
